const BASE_WITHDRAW_FEE_REDUCER: string = 'WITHDRAWS_FEE';
export const WITHDRAWS_FEE_LOADING = `${BASE_WITHDRAW_FEE_REDUCER}_LOADING`;
export const WITHDRAWS_FEE_ERROR = `${BASE_WITHDRAW_FEE_REDUCER}_ERROR`;
export const WITHDRAWS_FEE_SUCCESS = `${BASE_WITHDRAW_FEE_REDUCER}_SUCCESS`;
